import { Button } from '@cian/ui-kit';
import * as React from 'react';

interface IValuationPrimaryButtonProps {
  children: string;
  className?: string;
  onClick(): void;
  testId?: string;
}

export const ValuationPrimaryButton = React.forwardRef<HTMLButtonElement, IValuationPrimaryButtonProps>(
  (props, ref) => {
    const { children, onClick, className, testId = '' } = props;

    return (
      <div className={className} data-name={testId}>
        <Button ref={ref} theme="fill_primary" size="L" fullWidth onClick={onClick}>
          {children}
        </Button>
      </div>
    );
  },
);

ValuationPrimaryButton.displayName = 'ValuationPrimaryButton';
